import React from "react";
import * as Mui from "@mui/material";
import { Integration } from "model/integration";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

interface Props {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	name?: string;
	oauthId?: string;
	clientId?: string;
	onNameChange: (name: string) => void;
	onOauthIdChange: (oauthId: string) => void;
	onClientIdChange: (clientId: string) => void;
	onSave: () => void;
}

export class GoogleLoginModal extends React.Component<Props> {

	public render() {
		const { open, onClose, integration, name, oauthId, clientId, onNameChange, onOauthIdChange, onClientIdChange, onSave } = this.props;

		return (
			<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
				<Mui.Grid container direction="column" spacing={2}>
					<Mui.Grid item>
						<Mui.TextField
							label="Name" placeholder={integration.integrationType.name}
							value={name || ""} onChange={e => onNameChange(e.target.value)}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.TextField
							label="OAuth Client ID" value={oauthId || ""}
							onChange={e => onOauthIdChange(e.target.value)}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.TextField
							label="OAuth Client Secret" value={clientId || ""}
							onChange={e => onClientIdChange(e.target.value)}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Button variant="contained" color="primary" onClick={onSave}>Save</Mui.Button>
					</Mui.Grid>
				</Mui.Grid>
			</SimpleIntegrationModal>
		);
	}

}
